import { Button } from '@mui/material'

import { IonInformationModal } from '@/components/organisms/functionals'
import { useTranslation } from '@/core'
import { Organism } from '@/core/architecture'
/**
 * @description
 * ポイント不足時にポイント購入を促すモーダル
 */
export const PointInsufficientModal: Organism<{
  open: boolean
  onClose: () => void
  onConfirm: () => void
}> = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation('gachaDetail')
  return (
    <IonInformationModal
      open={open}
      onClose={onClose}
      title={t('purchasePointConfirmTitle')}
      content={t('purchasePointConfirmDesc')}
      cancelText={t('cancel')}
      buttons={
        <Button
          sx={{ minWidth: 212 }}
          variant="contained"
          color="primary"
          size="large"
          onClick={onConfirm}
        >
          {t('toBuy')}
        </Button>
      }
    />
  )
}
